import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 1 }

import { computed, onMounted, ref } from 'vue'
import { useStore } from 'vuex'

declare const gapi: any

export default /*#__PURE__*/_defineComponent({
  __name: 'ZeroTouch',
  setup(__props) {

const store = useStore()

const container = ref<HTMLElement | null>(null)

const isHttps = computed(() => location.protocol === 'https:')

onMounted(async () => {
  if (!isHttps.value) return

  const { value } = await store.dispatch('createWebToken')
  const url = `https://enterprise.google.com/android/zero-touch/embedded/companyhome?token=${value}&dpcId=com.google.android.apps.work.clouddpc`

  const div = document.createElement('div')

  gapi.load('gapi.iframes', () => {
    const options = {
      url,
      where: div,
      attributes: {
        style: 'width: 1000px; height:1000px',
        scrolling: 'yes',
      },
    }
    gapi.iframes.getContext().openChild(options)
  })

  container.value?.appendChild(div)
})

return (_ctx: any,_cache: any) => {
  return (isHttps.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref_key: "container",
        ref: container
      }, null, 512))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, "Https (SSL) is required to load Zero-touch portal"))
}
}

})